import { useCallback, useMemo, useState } from 'react'

const useSwitch = (defaultOn = false) => {
  const [on, setOn] = useState(defaultOn)

  const open = useCallback(() => {
    setOn(true)
  }, [])

  const close = useCallback(() => {
    setOn(false)
  }, [])

  const toggle = useCallback(() => {
    setOn((prev) => !prev)
  }, [])

  return useMemo(
    () => ({
      on,
      open,
      close,
      toggle,
    }),
    [close, on, open, toggle]
  )
}

export { useSwitch }
